import { render, staticRenderFns } from "./RecommendNewsList.vue?vue&type=template&id=e520a65a&scoped=true"
import script from "./RecommendNewsList.vue?vue&type=script&lang=js"
export * from "./RecommendNewsList.vue?vue&type=script&lang=js"
import style0 from "./RecommendNewsList.vue?vue&type=style&index=0&id=e520a65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e520a65a",
  null
  
)

export default component.exports